import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 116 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M58 0C90.0325 0 116 25.9675 116 58C116 90.0325 90.0325 116 58 116C25.9675 116 0 90.0325 0 58C0 25.9675 25.9675 0 58 0ZM56.1749 92.9268L23.0932 60.3463C21.9301 59.2009 21.8964 57.3358 23.0172 56.149L28.5599 50.2802C29.6908 49.0829 31.5754 49.021 32.7823 50.1416L48.9741 65.1763C49.614 65.7704 50.6545 65.3166 50.6545 64.4435V24.5697C50.6545 22.9128 51.9977 21.5697 53.6545 21.5697H62.9054C64.5623 21.5697 65.9054 22.9128 65.9054 24.5697V64.4435C65.9054 65.3166 66.946 65.7704 67.5859 65.1763L83.7777 50.1416C84.9846 49.021 86.8692 49.0829 88 50.2802L93.5428 56.149C94.6636 57.3358 94.6299 59.2009 93.4668 60.3463L60.3851 92.9268C59.2173 94.0769 57.3427 94.0769 56.1749 92.9268Z"
	})
});
export default SvgArrow;
